export class GrupoDescuento {
        //  ? significa opcional
        public codGrupo: number;
        public codEmpresa: number;
        public descripcion: string;
        public descuento: number;
        constructor() { }
}
